
import APIConstant from '../utils/pathConstants';
import api from '../utils/apiClient';
import moment from 'moment';
import Toast from '../components/Shared/Toast/Toast';
import { disconnectSocket } from './useSocket';

export default class CommonConfig {

    static isEmpty = function (value) {
        if (value === undefined || value === null || value === '' || value === 'null') {
            return true;
        } else {
            if (typeof value === 'string') {
                return value.trim() === "";
            } else {
                return false;
            }
        }
    }

    static orgOwnerRoles = ['School', 'College'];

    static isOrgOwner = function (userRole) {
        return CommonConfig.orgOwnerRoles.includes(userRole);
    }

    static nameTypeList = [
        { label: 'First Name/Surname', value: 'FirstSurname' },
        { label: 'Surname/First Name', value: 'SurnameFirstName' },
        { label: 'First Name/Father Name/Surname', value: 'FirstFatherNameSurname' },
        { label: 'Surname/First Name/Father Name', value: 'SurnameFirstFatherName' },
        { label: 'First Name/Mother Name/Surname', value: 'FirstMotherNameSurname' },
        { label: 'Surname/First Name/Mother Name', value: 'SurnameFirstMotherName' },
    ];

    static composeFullName = function (format, parts) {
        const { FirstName, SurName, FName, MName } = parts || {};
        const formats = {
            FirstSurname: [FirstName, SurName],
            SurnameFirstName: [SurName, FirstName],
            FirstFatherNameSurname: [FirstName, FName, SurName],
            SurnameFirstFatherName: [SurName, FirstName, FName],
            FirstMotherNameSurname: [FirstName, MName, SurName],
            SurnameFirstMotherName: [SurName, FirstName, MName],
        };
        const selected = formats[format] || formats.FirstSurname;
        return selected.map((p) => (p || '').trim()).filter(Boolean).join(' ');
    }

    static isObjectEmpty = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    static filterTwoArray = function (data, filters) {
        return data.filter(e => {
            try {
                filters.forEach(o => {
                    Object.keys(o).forEach(key => {
                        if (e[key] !== o[key]) throw new 1;
                    });
                });

                return true;
            } catch (e) {
                return false;
            }
        });
    }

    static getDatesBetweenDates = function (startDate, endDate) {
        let dates = []
        //to avoid modifying the original date
        const theDate = new Date(startDate)
        while (theDate < endDate) {
            dates = [...dates, new Date(theDate)]
            theDate.setDate(theDate.getDate() + 1)
        }
        dates.splice(0, 1)
        return dates
    }

    static amountValidate = function (e) {
        var t = e;
        e = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t.indexOf("-") != -1 ? t.substr(1, t.length) : t;
        return e;
    }

    static addDaysToDates = function (date, noOfDays) {
        var theDate = date;
        theDate.setDate(theDate.getDate() + noOfDays);
        return theDate;
    }

    static dateFormat = {
        dateTime: 'MM/DD/YYYY hh:mm:ss A',
        dateOnly: 'MM/DD/YYYY',
        dateFirst: 'DD/MM/YYYY',
        forDatePicker: 'DD-MM-YYYY',
        yearOnly: 'YYYY',
        dbDateTime: 'YYYY-MM-DD HH:mm:ss',
        timeOnly: 'HH:mm'
    }

    static loginData = function () {
        if (localStorage.getItem('ERPLoginData')) {
            return JSON.parse(localStorage.getItem('ERPLoginData'));
        }
        else {
            return ""
        }
    }

    static getUserAccess = function (moduleName) {
        if (this.getCookie('ERPLoginData')) {
            let data = JSON.parse(localStorage.getItem('userAccessData'));
            let moduleAccess = data?.filter(x => x?.ServiceName === moduleName);
            const accessData = moduleAccess ? moduleAccess[0]?.AccessMasterList : {};
            return accessData;

        } else {
            return ""
        }
    }

    static randomString = function (length) {
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    static getPanNumberFromGST = function (gst) {
        if (gst) {
            var result = gst.substr(2, 10);
        }
        return result;
    }

    static ExcelDateToJSDate = function (serial) {
        var utc_days = Math.floor(serial - 25569);
        var utc_value = utc_days * 86400;
        var date_info = new Date(utc_value * 1000);

        var fractional_day = serial - Math.floor(serial) + 0.0000001;

        var total_seconds = Math.floor(86400 * fractional_day);

        var seconds = total_seconds % 60;

        total_seconds -= seconds;

        var hours = Math.floor(total_seconds / (60 * 60));
        var minutes = Math.floor(total_seconds / 60) % 60;

        return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    }

    static convertImgToBase64 = async function (url) {
        return fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(blob)
            }))
    }

    static base64toFile = function (dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    static findFileNameFromURL = function (urlPath) {
        var url = urlPath;
        var filename = url.substring(url.lastIndexOf('/') + 1);
        return filename;
    }

    static findExtesionFromURL = function (urlPath) {
        const types = new Map([["jpg", "img"], ["jpeg", "img"], ["png", "img"], ["gif", "img"], ["mp4", "video"], ["3gp", "video"]])

        const url = new URL(urlPath)
        return url.pathname.split(".")[1]
    }

    static filterCaseInsensitive = function (filter, row) {
        const id = filter.pivotId || filter.id;
        const content = row[id];

        if (typeof content !== 'undefined') {
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {
                return String(content).toLowerCase().includes(filter.value.toLowerCase());
            }
        }

        return true;
    }

    static getIndianFormatAmount = function (amount) {
        var x = amount;
        x = x.toString();
        var afterPoint = '';
        if (x.indexOf('.') > 0)
            afterPoint = x.substring(x.indexOf('.'), x.length);
        x = Math.floor(x);
        x = x.toString();
        var lastThree = x.substring(x.length - 3);
        var otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers != '')
            lastThree = ',' + lastThree;
        return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
    }

    static RegExp = {
        phoneRegExp: /^([0-9]+\s?)*$/g,
        RateRegex: /^(\$|)([1-9]\d{0,2}(\.\d{2})*|([1-9]\d*))(\.\d{2})?$/,
        number: /^[0-9\b]+$/,
        onlyNumber: /[a-zA-Z~`!@#$%^&*()_+=-{}|:"<>?,;']+$/,
        // onlyDecimal: /^[0-9]+(\.[0-9][0-9])?$/,
        onlyDecimal: /^\d*\.?\d{0,2}$/,
        phoneNumber: /^([0-9]+\s?)*$/g,
        // email : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9-]+\.[A-Z]{2,6}$/ig,
        email: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        CompanyName: /[!@~`#$%^&*()_+\-=\]{};':"\\|,.<>?]/,
        zipCode: /^([a-zA-Z0-9]+\s?)*$/g,
        regExpNumber: /[0-9]/g,
        regExpUpperCase: /[A-Z]/g,
        regExpLowerCase: /[a-z]/g,
        phone: /^[0-9]{10}$/,
        regExpSpecialCharacter: /[!@#$%^&*(),.?":{}|<>]/g,
        RateRegex: /^(\$|)([1-9]\d{0,3}(\.\d{3})*|([1-9]\d*))(\.\d{3})?$/
    }

    static showErrorMsg = function (msg) {
        return (
            <span className="text-danger" style={{ color: 'red' }}>
                <span className="field-validation-error">{msg}</span>
            </span>
        )
    }

    static getUserMenu = async (userData, navigate, type) => {
        try {
            let userId = userData?._id;
            let userType = userData?.UserType;
            if (userData?.UserRole === 'Parent') {
                if (CommonConfig.isEmpty(userData?.SelectedChildData)) {
                    navigate('/childreen-list');
                    return;
                }
                userId = !CommonConfig.isEmpty(userData?.SelectedChildData) ? userData?.SelectedChildData?._id : userData?._id;
                userType = !CommonConfig.isEmpty(userData?.SelectedChildData?.UserType) ? userData?.SelectedChildData?.UserType : userData?.UserType;
            }
            const data = { UserId: userId, RoleId: userType };
            const res = await api.post(APIConstant.path.getUserMenu, data);
            if (res.success) {
                if (res.data.length) {
                    const item = res.data?.[0];
                    const redirectPath = !item
                        ? "/edit-profile"
                        : !item.ParentId
                            ? (item?.Children && item.Children.length > 0
                                ? item.Children[0].Path
                                : item.Path)
                            : item.Path;

                    navigate((redirectPath == '' || redirectPath == null) ? '/edit-profile' : redirectPath);
                } else if (userData?.UserRole === 'Parent') {
                    Toast.error({ message: 'No menu assigned for the selected child. Please contact administrator.' });
                    navigate('/childreen-list');
                } else {
                    navigate('/edit-profile');
                }
            }
        } catch (err) {
            console.error('Error fetching user menu:', err);
        }
    };

    static getCookie(key) {
        const data = localStorage.getItem(key);
        return data;
    }

    // Auth token query param for opening/downloading fileAccess-gated files
    // in a new tab / download, where the cookie may not ride.
    static fileToken = () => encodeURIComponent(localStorage.getItem('access_token') || '');

    // Stable per-browser id so a re-login from this browser reuses its session
    // (multi-session dedup) instead of consuming another of the 3 device slots.
    static getDeviceId = function () {
        try {
            let id = localStorage.getItem('edutattva_device_id');
            if (!id) {
                id = (window.crypto && window.crypto.randomUUID)
                    ? window.crypto.randomUUID()
                    : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
                localStorage.setItem('edutattva_device_id', id);
            }
            return id;
        } catch (e) {
            return '';
        }
    };

    static setCookie(key, value) {
        localStorage.setItem(key, value);
    }

    static removeCookie(key) {
        localStorage.removeItem(key);
    }

    static handleLogout = async (userId, navigate) => {
        try {
            await CommonConfig.saveUserDetails(
                userId,
                CommonConfig.loginData()
            );

            await api.post(APIConstant.path.logout, {
                id: userId
            });

        } catch (err) {
            console.error('Logout error:', err);
        } finally {
            CommonConfig.clearAuthData();
            navigate('/login');
            Toast.success({ message: 'Logged out successfully' });
        }
    };


    static clearAuthData = () => {
        disconnectSocket();
        const deviceId = localStorage.getItem('edutattva_device_id');
        localStorage.clear();
        if (deviceId) localStorage.setItem('edutattva_device_id', deviceId);
        CommonConfig.removeCookie('ERPLoginData');
        CommonConfig.removeCookie('access_token');
        CommonConfig.removeCookie('refresh_token');
        CommonConfig.removeCookie('refreshValue');
        CommonConfig.removeCookie('loggedIn')
        CommonConfig.removeCookie('userAccessData');
        CommonConfig.removeCookie('_grecaptcha');
        CommonConfig.removeCookie('selectedAcademicYear');

    };

    static handleCatchLogout = async (navigate) => {
        disconnectSocket();
        const deviceId = localStorage.getItem('edutattva_device_id');
        localStorage.clear();
        if (deviceId) localStorage.setItem('edutattva_device_id', deviceId);
        CommonConfig.removeCookie('access_token');
        CommonConfig.removeCookie('refresh_token');
        CommonConfig.removeCookie('ERPLoginData');
        CommonConfig.removeCookie('loggedIn');
        CommonConfig.removeCookie('refreshValue');
        CommonConfig.removeCookie('_grecaptcha');
        CommonConfig.removeCookie('userAccessData');
        navigate('/login');
        Toast.success({ message: 'Logged out successfully' });
    };

    static getFinancialYears = async (userId) => {
        try {
            const data = { UserID: userId };
            const response = await api.post(APIConstant.path.getAcademicCalanderTemplateList, data);

            if (response.success && response?.data?.length) {
                const years = response?.data?.flatMap((y) =>
                    y?.CalendarValue?.map((x) => ({
                        ...x,
                        label: `${y?.TitleName}(${moment(x?.StartDate).format("MM/YYYY")}-${moment(x?.EndDate).format("MM/YYYY")})`,
                        _id: x?._id,
                    }))
                );
                return years;
            }

            return [];
        } catch (err) {
            console.error("Error fetching financial years:", err);
            return [];
        }
    };

    static getCurrentFinancialYear = (dataList = []) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        const startYear = currentMonth >= 4 ? currentYear : currentYear - 1;
        const endYear = startYear + 1;
        const financialYearLabel = `${startYear}-${endYear}`;

        return dataList.find((y) => y.label === financialYearLabel) || null;
    };

    static saveUserDetails = async (id, loginData) => {
        try {
            const yearList = loginData?.SelectedAcademicYearList;
            const result = yearList && typeof yearList === 'object'
                ? Object.entries(yearList).map(([childId, academicId]) => ({
                    ChildId: childId,
                    AcademicYearId: academicId
                }))
                : [];

            let data = {
                id: id,
                SelectedClassfilter: loginData?.SelectedChildData?._id ?? '',
                SelectedAcademicYearList: result
            };
            await api.post(APIConstant.path.AddUpdateUser, data).then(async response => {
                let res = response;
                if (res.success) {

                }
            })
                .catch((err) => {
                    console.error(err);
                });
        } catch (error) {
            console.error('saveUserDetails error:', error);
        }
    }

    static parseDDMMYYYYToDate = (str) => {
        if (!str) return null;
        if (str instanceof Date) return str; 
        if (typeof str !== 'string') return null;

        const parts = str.split('/');
        if (parts.length !== 3) return null;

        const [dStr, mStr, yStr] = parts;
        const d = Number(dStr);
        const m = Number(mStr);
        const y = Number(yStr);

        if (!Number.isInteger(d) || !Number.isInteger(m) || !Number.isInteger(y)) return null;
        if (y < 1000 || m < 1 || m > 12 || d < 1 || d > 31) return null;

        const date = new Date(`${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
        return isNaN(date) ? null : date;
    };

}